<template>
  <v-row justify="center">
    <v-dialog v-model="attivo" persistent>
      <v-form
        ref="form"
        @submit.prevent="onSubmit"
        v-model="valid"
        lazy-validation
      >
        <v-flex>
          <v-card>
            <v-card-title>
              <span class="text-h5">{{ $t("introduzione.titolo") }} </span>
            </v-card-title>
            <v-card-text>
              <v-container>
                <v-alert
                  border="left"
                  colored-border
                  color="primary accent-4"
                  elevation="2"
                  class="text-wrap"
                >
                  <v-col
                    cols="12"
                    md="12"
                    v-for="(norma, index) in consensi"
                    :key="index"
                  >
                    <v-checkbox
                      class="ma-0"
                      false-value="N"
                      true-value="S"
                      :label="checkLingua(norma)"
                      :class="font - weight - medium"
                      :required="norma.obbligatorio == 'S' ? true : false"
                      hide-details
                      :rules="tipoCheckBox(norma.obbligatorio)"
                      v-model="norma.selezionato"
                    ></v-checkbox
                    ><v-btn
                      v-if="norma.link"
                      x-small
                      class="float-end"
                      dark
                      :href="norma.link"
                      target="_blank"
                    >
                      normativa
                    </v-btn>
                  </v-col>
                </v-alert>

                <!--inizio
                <v-alert
                  border="left"
                  colored-border
                  color="primary accent-4"
                  elevation="2"
                >
                  <v-col cols="12">
                    <v-checkbox
                      v-model="consensi.consenso5"
                      v-bind:label="
                        '* ' + $t('introduzione.consenso_norme_condotta')
                      "
                      @click="dialogNorme = true"
                      required
                      hide-details
                      :rules="[(v) => !!v || 'Item is required']"
                    ></v-checkbox>
                  </v-col>

                  
                  <v-dialog
                    v-model="dialogPrivacy"
                    scrollable
                    persistent
                    max-width="900px"
                  >
                    <v-card>
                      <v-card-title class="text-h5">
                        Testo della normativa
                      </v-card-title>
                      <v-divider></v-divider>
                      <v-card-text>
                        <privacy></privacy>
                      </v-card-text>
                      <v-divider></v-divider>
                      <v-card-actions>
                        <v-spacer></v-spacer>

                        <v-btn
                          color="primary darken-1"
                          @click="dialogPrivacy = false"
                        >
                          {{ $t("introduzione.conferma") }}
                        </v-btn>
                      </v-card-actions>
                    </v-card>
                  </v-dialog>
               

                  <v-dialog
                    v-model="dialogNorme"
                    scrollable
                    persistent
                    max-width="900px"
                  >
                    <v-card>
                      <v-card-title class="text-h5">
                        Norme di condotta nel caso di molestie sessuali e morali
                      </v-card-title>
                      <v-divider></v-divider>
                      <v-card-text>
                        <norme-condotta></norme-condotta>
                      </v-card-text>
                      <v-divider></v-divider>
                      <v-card-actions>
                        <v-spacer></v-spacer>

                        <v-btn
                          color="primary darken-1"
                          @click="dialogNorme = false"
                        >
                          {{ $t("introduzione.conferma") }}
                        </v-btn>
                      </v-card-actions>
                    </v-card>
                  </v-dialog>
                </v-alert>-->
                <!--fine-->
              </v-container>
            </v-card-text>
            <v-card-actions>
              <v-spacer
                ><small>({{ $t("campiObbligatori") }})</small></v-spacer
              >
              <v-btn color="primary darken-1" @click="validazione">
                {{ $t("conferma") }}
              </v-btn>
              <v-btn color="primary darken-1" text @click="chiudi">
                {{ $t("chiudi") }}
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-flex>
      </v-form>
    </v-dialog>
    <v-snackbar
      v-model="snackbar"
      :timeout="timeout"
      elevation="24"
      color="primary"
    >
      <b>{{ $t("checkCampiObbligatori") }}</b>
    </v-snackbar>
  </v-row>
</template>

<script>
//import privacy  from "@/assets/privacy.html";
//import privacy from "@/components/testiHtml/privacy.vue";
//import normeCondotta from "@/components/testiHtml/normeCondotta.vue";
//import api from "@/services/EventService.js";

export default {
  name: "introduzione",
  //components: { privacy, normeCondotta },
  props: {
    attivo: {
      default: false,
      type: Boolean,
    },
  },
  data: () => ({
    norme: "",
    snackbar: false,
    timeout: 2000,
    dialog: true,
    dialogNorme: false,
    dialogPrivacy: false,
    valid: false,
    normePrivacy: "",
  }),

  computed: {
    consensi() {
      return this.$store.state.introduzione.consensi;
    },
  },
  methods: {
    tipoCheckBox(flagSN) {
      const rules = [];

      if (flagSN == "S") {
        // The checkbox is valid only if its value is 'S'
        const rule = (v) => v === "S" || "required";
        rules.push(rule);
      }
      return rules;
    },
    checkLingua(norma) {
      var testo = norma.obbligatorio == "S" ? "* " : "";
      if (this.$i18n.locale == "en") {
        return testo + norma.TESTO_ENG;
      } else if (this.$i18n.locale == "es") {
        return testo + norma.TESTO_ESP;
      } else {
        return testo + norma.TESTO;
      }
    },
    apriNorma(link) {
      alert(link);
    },

    async chiudi() {
      if (!this.$refs.form.validate()) {
        await this.$store.dispatch("setStepNoCompletoEvent", 1);
      }
      this.attivo = false;
    },
    async validazione() {
      if (this.$refs.form.validate()) {
        await this.$store.dispatch("setStepCompletoEvent", 1);

        this.attivo = false;
      } else {
        this.snackbar = true;
      }
    },
  },
  mounted() {
    //this.carica_norme();
  },
};
</script>

<style scope>
label {
  display: inline-block;
  margin-bottom: 0;
}

.v-btn__content {
  width: 100%;
  white-space: normal;
}
</style>
